import styled from '@emotion/styled'
import { FlexMods, FlexParentBase, ifDirectDescendant } from '../../../styles'
import { SpaceProperties } from '../../../styles/definitions/size/typographyScale'

/**
 * Separates the passed children by splitting them apart as much as possible.
 * Useful for aligning an element to each edge.
 */
export const Split = styled.div`
	${FlexParentBase};
	${FlexMods.Parent({ wrap: true, gap: SpaceProperties.Base })};
	${ifDirectDescendant(FlexMods.Child({ shrink: 0 }))};
`
